import { createContext } from 'react';
import { Moment } from 'moment';

export interface ISettings {
  initDeleteHalt?: (ids: string[], listType: string, haltDate?: Moment) => void;
}

export const SettingsContext = createContext<ISettings>({});
